import React from 'react';
import { ArrowRight } from 'lucide-react';
import { products } from '../mockData';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const ProductsSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    'Wholesale Supply',
    'Bulk Orders',
    'Dealer Support',
    'Product Consultation',
    'Technical Assistance',
    'After-Sales Support'
  ];

  return (
    <section id="products" className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Products & Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive range of genuine printer consumables and accessories
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {products.map((product) => (
            <Card key={product.id} className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden">
              <div className={`relative h-48 overflow-hidden ${product.imageFit === 'contain' ? 'bg-gray-50' : ''}`}>
                <img
                  src={product.image}
                  alt={product.title}
                  className={`w-full h-full ${product.imageFit === 'contain' ? 'object-contain p-3' : `object-cover ${product.imagePosition || ''}`} group-hover:scale-110 transition-transform duration-500`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{product.title}</h3>
                <p className="text-gray-600 mb-4">{product.description}</p>
                <Button
                  onClick={scrollToContact}
                  variant="link"
                  className="text-blue-900 hover:text-blue-700 p-0 h-auto font-semibold group/btn"
                >
                  Get Quote
                  <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform duration-200" size={16} />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Services Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
          <div className="text-center mb-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Our Services
            </h3>
            <p className="text-gray-600">
              Comprehensive support for all your printing needs
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((service, index) => (
              <div
                key={index}
                className="flex items-center gap-3 p-4 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors duration-200"
              >
                <div className="w-2 h-2 bg-blue-900 rounded-full"></div>
                <span className="text-gray-800 font-medium">{service}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Supported Brands */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6 font-medium">Supporting All Major Brands</p>
          <div className="flex flex-wrap justify-center items-center gap-6">
            <div className="bg-white rounded-lg shadow px-4 py-3 h-16 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/v24j8xn2_epson.png" 
                alt="Epson" 
                className="max-h-12 w-auto object-contain"
              />
            </div>
            <div className="bg-white rounded-lg shadow px-4 py-3 h-16 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/4084qqny_Canon.jpg" 
                alt="Canon" 
                className="max-h-8 w-auto object-contain"
              />
            </div>
            <div className="bg-white rounded-lg shadow px-4 py-3 h-16 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/q7cdd6pg_HP.jpg" 
                alt="HP" 
                className="max-h-10 w-auto object-contain"
              />
            </div>
            <div className="bg-white rounded-lg shadow px-4 py-3 h-16 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/j4sez5hq_brother.png" 
                alt="Brother" 
                className="max-h-12 w-auto object-contain"
              />
            </div>
            <div className="bg-white rounded-lg shadow px-4 py-3 h-16 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/em3xh1st_ImageKing%20Logo%20whatsapp%20community.jpg" 
                alt="Image King" 
                className="max-h-10 w-auto object-contain"
              />
            </div>
            <div className="bg-white rounded-lg shadow px-4 py-3 h-16 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/mushuinu_tvse.png" 
                alt="TVS Electronics" 
                className="max-h-10 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
